// https://inclusive-components.design/collapsible-sections/

export default class A11yDrawer {
  constructor(node) {
    this.node = node
    this.toggle = this.node.querySelector('[data-a11y-toggle]')
    this.target = this.node.querySelector('[data-a11y-target]')
    this.button = this.toggle.querySelector('button')
    this.button.addEventListener('click', () => this.handleToggle())
  }

  handleToggle() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true'
    expanded ? this.close() : this.open()
  }

  open() {
    this.button.setAttribute('aria-expanded', true)
    this.node.classList.add('active')
    this.target.hidden = false
  }

  close() {
    this.button.setAttribute('aria-expanded', false)
    this.node.classList.remove('active')
    this.target.hidden = true
  }

  valueOf() {
    return this
  }
}
